import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (this.authService.candidateId || this.authService.userType) {
      return true;
    } else {
      if (next.data.roles == 'recruiter') {
        this.router.navigate(['recruiter-login']);
      } 
      if (next.data.roles == 'candidate') {
        this.router.navigate(['candidate-login']);
      }
      return false;
    }
  }
}
